import { Module } from 'vuex';
import { JobState, state } from './state';
import { getters } from './getters';
import { mutations } from './mutations';
import { actions } from './actions';

const job: Module<JobState, any> = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default job;
